import { Box, Heading, Text } from '@chakra-ui/react'

export const Account = () => {
  return (
    <Box p={4}>
      <Heading mb={4}>Account</Heading>
      <Text>Account page coming soon...</Text>
    </Box>
  )
} 